const BANNED_COMPONENTS = ['checkout', 'booking'];

const CHAT_STORAGE_CACHE = 1000 * 60 * 60 * 8; // 8 hours

const CHAT_STORAGE_KEY = 'MIRAI:LISA:CHAT';

const DEFAULT_NAME = 'Sarai';

const DEFAULT_PRIVACY_ID = '100379008';

const DEFAULT_PRIVACY_URL = process.env.SERVICE_AGREEMENT;

const DEFAULT_ACTIONS = [
  {
    intent: 'BOOKING_CREATE',
    text: 'I’d like to make a **reservation**',
    options: [
      {
        text: 'I’d like to make a reservation for next weekend.',
      },
      {
        text: 'Can I make a **reservation** for tomorrow?',
      },
      {
        text: 'I need a booking for two adults.',
      },
    ],
  },
  {
    intent: 'HOTEL_INFO',
    text: 'I would like to know more about the hotel.',
    options: [
      {
        text: 'Where is the hotel located?',
      },
      {
        text: 'What is the hotel’s email and phone number?',
      },
      {
        text: 'What payment methods does the hotel accept?',
      },
      {
        text: 'What time is the hotel’s check-in?',
      },
    ],
  },
  {
    intent: 'LOGIN',
    text: 'I would like to manage my membership.',
    options: [
      {
        text: 'How can I log into the membership?',
      },
      {
        text: 'I want to change my personal details.',
      },
      {
        text: 'How can I sign up for the membership?',
      },
    ],
  },
  {
    intent: 'BOOKING_CANCEL',
    text: 'I need to cancel my booking',
  },
];

const DELAY_RESPONSE = 500;

const EVENT = {
  INPUT_COMPONENT: 'EVENT_INPUT_COMPONENT',
};

const INPUT_MODE = {
  TEXT: 'text',
  AUDIO: 'audio',
  WHATSAPP: 'whatsapp',
  RATING: 'rating',
};

const INTENT = {
  BOOK: 'BOOK',
  BOOKING_CREATE: 'BOOKING_CREATE',
  BOOKING_CANCEL: 'BOOKING_CANCEL',
  BOOKING_QUERY: 'BOOKING_QUERY',
  BOOKING_VIEW: 'BOOKING_VIEW',
  BOOKING_SEND: 'BOOKING_SEND',
  OFFERS: 'OFFERS',
  HOTEL_INFO: 'HOTEL_INFO',
  GREETINGS: 'GREETINGS',
  FAREWELLS: 'FAREWELLS',
  SIGNUP: 'SIGNUP',
  LOGIN: 'LOGIN',
  PROFILE: 'PROFILE',
};

const NAME = 'Sarai';

const PRIVACY_FALLBACK_LOCALE = 'en-GB';

const VERBOSE_DATE_FORMAT = { weekday: 'short', month: 'short', day: 'numeric' };

export {
  BANNED_COMPONENTS,
  CHAT_STORAGE_CACHE,
  CHAT_STORAGE_KEY,
  DEFAULT_ACTIONS,
  DEFAULT_NAME,
  DEFAULT_PRIVACY_ID,
  DEFAULT_PRIVACY_URL,
  DELAY_RESPONSE,
  EVENT,
  INPUT_MODE,
  INTENT,
  NAME,
  PRIVACY_FALLBACK_LOCALE,
  VERBOSE_DATE_FORMAT,
};
